export default {
  AUTH_TOKEN: 'AUTH_TOKEN',
};
